module.exports = __webpack_public_path__ + "5a57891a426a1c46ea557fcce0648b1a.jpg";